module.exports = __webpack_public_path__ + "img/0Q3B5795_Black_MockedUp.d4dad900.jpg";